<div class="main-content">
  <app-header [title]="'FEEDBACK_FORM.TITLE' | translate" />
  <div class="row pt-5 mt-4 mt-md-0">
    <div class="col-12">
      @if (!showSuccess && !showError) {
        <app-icam-container
          [centralIcon]="true"
          [iconName]="'article'"
          [iconColor]="'#e30714'"
          [iconHeight]="'32px'"
          >
          @if (!isLoading) {
            <div class="feedback-container">
              <form [formGroup]="form" (ngSubmit)="onSubmit()" class="form-container feedback-form d-flex flex-column">
                <app-form-section-header [title]="'FEEDBACK_FORM.INSERT_FEEDBACK' | translate"></app-form-section-header>
                <div class="row">
                  <div class="col-12">
                    <div class="input-wrapper">
                      <label for="content">{{ 'FEEDBACK_FORM.content' | translate }}*</label>
                      <textarea
                        id="content"
                        formControlName="content"
                        class="form-control"
                        rows="5"
                        placeholder="{{ 'FEEDBACK_FORM.content_PLACEHOLDER' | translate }}"
                      ></textarea>
                      @if (form.get('content')?.invalid && form.get('content')?.touched) {
                        <div
                          class="invalid-feedback d-block"
                          >
                          @if (form.get('content')?.errors?.['required']) {
                            <span>
                              {{ 'FEEDBACK_FORM.REQUIRED_FIELD' | translate }}
                            </span>
                          }
                          @if (form.get('content')?.errors?.['minlength']) {
                            <span>
                              {{ 'FEEDBACK_FORM.MIN_LENGTH_ERROR' | translate }}
                            </span>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="input-wrapper">
                      <label for="rating">{{ 'FEEDBACK_FORM.RATING' | translate }}*</label>
                      <app-rating-input formControlName="rating"></app-rating-input>
                      @if (form.get('rating')?.invalid && form.get('rating')?.touched) {
                        <div
                          class="invalid-feedback d-block"
                          >
                          {{ 'FEEDBACK_FORM.REQUIRED_FIELD' | translate }}
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  class="button-form-submit"
                  [class.disabled]="!form.valid || isLoading"
                  [disabled]="!form.valid || isLoading"
                  >
                  @if (isLoading) {
                    <div class="d-flex justify-content-center">
                      <div class="spinner-border spinner-border-sm" role="status"></div>
                    </div>
                  } @else {
                    {{ 'FEEDBACK_FORM.SUBMIT' | translate }}
                  }
                </button>
              </form>
            </div>
          }
          @if (isLoading) {
            <div class="loading-container text-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
              </div>
              <p class="mt-3">{{ 'COMMON.LOADING' | translate }}</p>
            </div>
          }
        </app-icam-container>
      }

      @if (saveSuccess) {
        <app-icam-container
          [centralIcon]="true"
          [iconName]="'OK'"
          [iconColor]="'#00A5A9'"
          [iconHeight]="'60px'"
          >
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="success-title mt-4">
              {{ 'FEEDBACK_FORM.SUCCESS_TITLE' | translate }}
            </h1>
            <p class="subtitle my-3">
              {{ 'FEEDBACK_FORM.SUCCESS_DESCRIPTION' | translate }}
            </p>
            <button class="btn btn-primary mt-3" (click)="goBack()">
              {{ 'COMMON.GO_BACK' | translate }}
            </button>
          </div>
        </app-icam-container>
      }

      @if (saveError) {
        <app-icam-container
          [centralIcon]="true"
          [iconName]="'KO'"
          [iconColor]="'#e30714'"
          [iconHeight]="'60px'"
          >
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="error-title mt-4">
              {{ 'FEEDBACK_FORM.ERROR_TITLE' | translate }}
            </h1>
            <p class="subtitle my-3">
              {{ 'FEEDBACK_FORM.ERROR_DESCRIPTION' | translate }}
            </p>
            @if (errorMessage) {
              <div class="text-danger validation-errors">
                @for (line of errorMessage.split('\n'); track line) {
                  <p>{{ line }}</p>
                }
              </div>
            }
            <button class="btn btn-primary" (click)="tryAgain()">
              {{ 'COMMON.TRY_AGAIN' | translate }}
            </button>
            <button class="btn btn-outline-secondary mt-3" (click)="goBack()">
              {{ 'COMMON.GO_BACK' | translate }}
            </button>
          </div>
        </app-icam-container>
      }

      <div class="form-footer d-flex justify-content-between mt-4">
        @if (!showSuccess && !showError) {
          <div>
            <app-back-button
              class="app-back-button"
              [linkText]="'FEEDBACK_FORM.BACK'"
              (click)="goBack()"
            ></app-back-button>
          </div>
        }
      </div>
    </div>
  </div>
</div>
<app-footer-copyright />
